<template>
  <div id="outerTotalisticRuleEditter">
    <div>
      <div class="cell prev"
           :style="deadStyle"></div>
      <div v-for="(state, i) in config.rule.dead"
           :key="i"
           @click="onClick('dead', i)"
           class="cell next"
           :style="state ? aliveStyle : deadStyle">
      </div>
    </div>
    <div>
      <div class="cell prev"
           :style="aliveStyle"></div>
      <div v-for="(state, i) in config.rule.alive"
           :key="i"
           @click="onClick('alive', i)"
           class="cell next"
           :style="state ? aliveStyle : deadStyle">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  inject: ['config'],
  computed: {
    aliveStyle () {
      return {
        background: this.config.aliveColor
      }
    },
    deadStyle () {
      return {
        background: this.config.deadColor
      }
    }
  },
  methods: {
    onClick (key, i) {
      this.$emit('ruleChanged', {state: key, index: i})
    }
  }
}
</script>
<style scoped lang="scss">
.cell {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: solid 1px #222;
  margin-left:-1px;
  &.prev {
    margin-right: 10px;
  }
  &.next {
    cursor: pointer;
  }
}
</style>
